import React from "react";
import {ActionButton} from "./ActionButton";

type ModeChoiceProps = {
    onLoginClick: () => void;
    onRegisterClick: () => void;
};

export const ModeChoice: React.FC<ModeChoiceProps> = ({onLoginClick, onRegisterClick}) => {
    return (
        <div className="flex flex-col items-center justify-center gap-2 w-full">
            <ActionButton type='primary'onClick={onLoginClick}> Авторизуватись </ActionButton>
            <div className="text-sm font-medium leading-[18px] mt-8 mb-4">Не маєте облікового запису?</div>
            <ActionButton onClick={onRegisterClick}> Зареєструватись </ActionButton>
        </div>
    );
};